<div class="flex justify-content-center align-items-center text-xl font-bold" *ngIf="onExtendedMobile()">
	{{ titleId | translate }}
</div>
<div class="layout-content p-0 pt-3" [ngClass]="layoutMarginResponsive()">
	<div class="grid p-0">
		<div class="col-12">
			<p-tabView [scrollable]="true" [activeIndex]="supportTabIndex" (onChange)="changeTab($event)">
				<p-tabPanel header="{{ 'SUPPORT_REQUESTS' | translate }}">
					<app-tickets-list></app-tickets-list>
				</p-tabPanel>
				<p-tabPanel header="{{ 'TECHNICIANS' | translate }}">
					<app-technicians-list></app-technicians-list>
				</p-tabPanel>
			</p-tabView>
		</div>
	</div>
</div>